import { FocusGraph } from "@/components";
import RuleGraphProvider from "@/components/GraphVisualisation/providers/RuleGraphProvider";
import { ensureParsedGraph } from "@imminently/decisively-core";
import styled from "@emotion/styled";

export const AttributeGraph = ({ attribute, release }) => {
  const StyledFocusGraph = styled(FocusGraph)`
    height: 100%;
  `;

  return (
    <RuleGraphProvider graph={ensureParsedGraph(release.rule_graph)}>
      <StyledFocusGraph graph={release.rule_graph} focusNode={attribute} />
    </RuleGraphProvider>
  )
}
